var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "popWindow" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "close", on: { click: _vm.close } }, [
        _c("img", {
          attrs: {
            src: require("@/assets/images/official/close.png"),
            alt: "",
          },
        }),
      ]),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "top" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phone,
                expression: "phone",
              },
            ],
            attrs: { type: "text", placeholder: "请输入账号..." },
            domProps: { value: _vm.phone },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.phone = $event.target.value
              },
            },
          }),
        ]),
        _c("div", { staticClass: "bottom" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password",
              },
            ],
            attrs: { type: "password", placeholder: "请输入密码..." },
            domProps: { value: _vm.password },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.password = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "btn", on: { click: _vm.login } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }